import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusrentalinpune() {



const cardData =
{
  keyword: 'Mini Bus Rental in Pune',
  heading: 'Sanavi Travels: Mini Bus Rental in Pune',
  headingDescription: 'Sanavi Travels provides reliable and comfortable mini bus rental services in Pune for families, corporate groups, weddings, picnics, and outstation travel, offering well-maintained AC and Non-AC mini buses with professional drivers and flexible booking options.',

  top: 'Top Uses of Mini Bus Rental in Pune with Sanavi Travels',

  topPlaces: [
    {
      title: 'Corporate Travel & Office Commute',
      description: 'Mini bus rental in Pune is widely used for corporate travel, daily office commutes, meetings, seminars, and team outings. Companies prefer mini buses because they allow employees to travel together comfortably, arrive on time, and reduce dependency on multiple vehicles. Spacious seating, smooth suspension, and air-conditioned interiors ensure employees remain relaxed and productive even during peak traffic hours. Mini buses also help organizations maintain discipline in travel schedules, reduce transportation costs, and present a professional image when hosting clients or business partners.'
    },
    {
      title: 'Wedding Guest Transportation',
      description: 'For weddings and marriage functions, mini buses offer an organized and stress-free way to transport guests. Families can avoid confusion of coordinating many cars and ensure that all guests arrive together at venues, temples, or banquet halls. Comfortable seating, clean interiors, and professional drivers make the journey pleasant for elders, children, and relatives. Mini buses are especially useful for multiple wedding events spread across different locations in Pune.'
    },
    {
      title: 'Family Trips & Group Outings',
      description: 'Mini buses are ideal for family trips, birthday celebrations, religious visits, and group outings. Traveling together strengthens bonding and allows everyone to enjoy the journey as much as the destination. With ample legroom and luggage space, mini buses make short and long journeys comfortable, eliminating the fatigue of cramped seating or multiple vehicles.'
    },
    {
      title: 'Picnics & Leisure Tours',
      description: 'For picnics and leisure tours around Pune, mini bus rental ensures a relaxed and enjoyable start to the outing. Friends, colleagues, and families can chat, listen to music, and enjoy the ride together. The convenience of a single vehicle also simplifies logistics like parking and route coordination at tourist spots.'
    },
    {
      title: 'Outstation Travel',
      description: 'Mini buses are a popular choice for outstation travel from Pune to hill stations, pilgrimage destinations, and weekend getaways. Designed for longer journeys, these vehicles provide stability, comfort, and safety on highways and ghat sections, ensuring passengers arrive refreshed.'
    },
    {
      title: 'School & College Trips',
      description: 'Educational institutions often rely on mini buses for school and college trips. Safety, seating capacity, and professional drivers make mini buses suitable for transporting students responsibly while keeping costs under control.'
    },
    {
      title: 'Corporate Events & Conferences',
      description: 'Mini buses simplify transportation for corporate events and conferences by keeping groups together, ensuring punctual arrivals, and reducing coordination challenges.'
    },
    {
      title: 'Religious & Spiritual Tours',
      description: 'Mini bus rental is ideal for temple visits, pilgrimages, and spiritual tours around Pune, offering comfort and convenience for devotees of all age groups.'
    },
    {
      title: 'City Sightseeing',
      description: 'For Pune city tours and sightseeing, mini buses provide excellent visibility, comfort, and flexibility, allowing groups to explore attractions together.'
    },
    {
      title: 'Cost-Effective Group Travel',
      description: 'Mini bus rental offers an economical solution for group travel by reducing fuel, toll, and coordination costs compared to multiple cars.'
    }
  ],

  services: [
    {
      name: 'Mini Bus Rental in Pune',
      description: 'Sanavi Travels offers mini bus rental services in Pune tailored for families, corporate groups, weddings, picnics, school trips, and outstation travel. Our mini buses are clean, spacious, and well-maintained, featuring comfortable seating, smooth suspension, and optional air-conditioning. With experienced drivers and flexible rental plans, clients enjoy safe, punctual, and stress-free group transportation across Pune and nearby destinations.'
    },
    {
      name: 'AC Mini Bus Hire Pune',
      description: 'AC mini buses ensure a cool and comfortable environment, especially suitable for long journeys, corporate travel, and summer outings.'
    },
    {
      name: 'Non AC Mini Bus Rental Pune',
      description: 'Non-AC mini buses provide a cost-effective option while maintaining comfort and ample seating for group travel.'
    },
    {
      name: '12 Seater Mini Bus Pune',
      description: '12 seater mini buses are ideal for small groups, families, and executive teams needing compact yet comfortable transport.'
    },
    {
      name: '16 Seater Mini Bus Pune',
      description: '16 seater mini buses strike a balance between capacity and maneuverability, suitable for city and highway travel.'
    },
    {
      name: '20 Seater Mini Bus Pune',
      description: '20 seater mini buses accommodate larger groups comfortably, making them perfect for events and outings.'
    },
    {
      name: 'Mini Bus for Family Pune',
      description: 'Family trips become more enjoyable with mini bus travel, offering space, comfort, and safety for all members.'
    },
    {
      name: 'Mini Bus for Corporate Pune',
      description: 'Corporate clients benefit from punctual service, professional drivers, and organized group transportation.'
    },
    {
      name: 'Mini Bus for Group Pune',
      description: 'Group travel in a mini bus ensures everyone stays together, improving coordination and shared experiences.'
    },
    {
      name: 'Affordable Mini Bus Rental Pune',
      description: 'Affordable pricing makes mini bus rental accessible without compromising comfort or safety.'
    },
    {
      name: 'Best Mini Bus Service Pune',
      description: 'Sanavi Travels is known for reliable service, clean vehicles, and customer-focused operations.'
    },
    {
      name: 'Mini Bus with Driver Pune',
      description: 'Experienced drivers handle routes efficiently, ensuring safe and timely travel.'
    },
    {
      name: 'Mini Bus for Wedding Pune',
      description: 'Mini buses provide organized and comfortable transportation for wedding guests.'
    },
    {
      name: 'Mini Bus for Picnic Pune',
      description: 'Perfect for leisure outings and picnics, offering a relaxed group travel experience.'
    },
    {
      name: 'Outstation Mini Bus Pune',
      description: 'Outstation mini bus services support long-distance travel with comfort and reliability.'
    }
  ],

  tableData: [
    ['AC Mini Bus', 'Non AC Mini Bus'],
    ['12 Seater', '16 Seater'],
    ['20 Seater', 'Family Travel'],
    ['Corporate Use', 'Wedding & Picnic'],
    ['Local', 'Outstation']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Comfortable Group Travel',
      WhyChoosedescription: 'Mini buses provide spacious seating and smooth rides, ensuring passenger comfort on every journey.'
    },
    {
      WhyChooseheading: 'Professional Drivers',
      WhyChoosedescription: 'Licensed and experienced drivers ensure safety, punctuality, and route expertise.'
    },
    {
      WhyChooseheading: 'Well-Maintained Fleet',
      WhyChoosedescription: 'Regularly serviced vehicles guarantee reliability and cleanliness.'
    },
    {
      WhyChooseheading: 'Flexible Rental Plans',
      WhyChoosedescription: 'Customizable options suit different travel durations and requirements.'
    },
    {
      WhyChooseheading: 'Transparent Pricing',
      WhyChoosedescription: 'Clear pricing structures help clients plan travel budgets confidently.'
    },
    {
      WhyChooseheading: 'Suitable for All Occasions',
      WhyChoosedescription: 'Mini buses are ideal for family trips, corporate events, weddings, picnics, and outstation tours.'
    },
    {
      WhyChooseheading: '24/7 Customer Support',
      WhyChoosedescription: 'Dedicated support ensures smooth coordination and assistance at all times.'
    },
    {
      WhyChooseheading: 'Cost-Effective Solution',
      WhyChoosedescription: 'Mini bus rental reduces overall travel costs compared to multiple vehicles.'
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide mini bus rental services in Pune?',
    answer: 'Yes, Sanavi Travels offers mini bus rental services in Pune for various travel needs.'
  },
  {
    question: 'Are AC and Non AC mini buses available?',
    answer: 'Yes, both AC and Non AC mini bus options are available.'
  },
  {
    question: 'What seating capacities are offered?',
    answer: 'We provide 12, 16, and 20 seater mini buses.'
  },
  {
    question: 'Can mini buses be hired for weddings?',
    answer: 'Yes, mini buses are commonly used for wedding guest transportation.'
  },
  {
    question: 'Are mini buses suitable for corporate travel?',
    answer: 'Absolutely. Corporate clients frequently use mini buses for office commute and events.'
  },
  {
    question: 'Do you offer outstation mini bus services?',
    answer: 'Yes, we provide reliable outstation mini bus rentals from Pune.'
  },
  {
    question: 'Are drivers experienced?',
    answer: 'Yes, all drivers are trained, licensed, and experienced.'
  },
  {
    question: 'Is pricing transparent?',
    answer: 'Yes, our pricing is clear with no hidden charges.'
  },
  {
    question: 'Can routes and schedules be customized?',
    answer: 'Yes, pickup points and schedules can be customized.'
  },
  {
    question: 'Is customer support available?',
    answer: 'Yes, 24/7 customer support is available for all bookings.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshpande',
    feedback: 'We hired a mini bus from Sanavi Travels for a family picnic in Pune. The bus was clean, comfortable, and the driver was very professional. The entire journey was smooth and enjoyable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ritu Sharma',
    feedback: 'Sanavi Travels arranged a mini bus for our corporate outing. Everything was well organized, punctual, and comfortable. Highly recommended for group travel in Pune.',
    rating: 5
  }
];











































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];





const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus Rental in Pune - Sanavi Travels",
  "description": "Sanavi Travels provides mini bus rental services in Pune. Hire AC or Non AC mini buses in 12, 16, or 20 seater options for family trips, corporate travel, group outings, weddings, picnics, and outstation journeys with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2500+"
  }
};










  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Mini Bus Rental in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire mini buses in Pune with Sanavi Travels. AC, Non AC, 12/16/20 seater mini buses available for family trips, corporate travel, group outings, weddings, picnics, and outstation journeys with professional driver at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/312.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusrentalinpune;